import Localization from '~/client/src/shared/localization/LocalizationManager'

export const isEmptyFieldValue = (value: unknown): boolean =>
  value === undefined ||
  value === null ||
  value === '' ||
  (Array.isArray(value) && value.length === 0)

export const requiredFieldValidator = (value: unknown): true | string =>
  isEmptyFieldValue(value)
    ? Localization.translator.requiredFieldCannotBeEmpty
    : true

// null is the explicit "None" option (includeNoneOption) — an answered selection
export const requiredSelectFieldValidator = (value: unknown): true | string =>
  value === null ? true : requiredFieldValidator(value)
